import gql from 'graphql-tag';

export default gql`
  mutation deleteDistributions($distributionIds: [ID!]!) {
    deleteDistributions(distributionIds: $distributionIds)
  }
`;
